<template>
    <v-toolbar class="interface-browser__nav-page" height="30">
        <v-btn icon small :disabled="!hasPrevHistory" @click="prev">
            <v-icon size="20">arrow_back</v-icon>
        </v-btn>
        <v-btn icon small :disabled="!hasNextHistory" @click="next">
            <v-icon size="20">arrow_forward</v-icon>
        </v-btn>
        <v-btn icon small>
            <v-icon size="20">home</v-icon>
        </v-btn>
        <!--<v-btn icon @click="action('/web/search', 'Поиск')">-->
        <v-btn icon small>
            <v-icon size="20">search</v-icon>
        </v-btn>

        <span class="ml-4 mr-2 interface-browser__url-title">Url:</span>
        <v-flex xs12 sm6 md3>
            <v-text-field disabled :value="active.url" class="browser-text-field"></v-text-field>
        </v-flex>
    </v-toolbar>
</template>

<script>

    export default {
        components: {},
        props: {
            value: Object
        },
        data () {
            return {}
        },
        computed: {
            hasPrevHistory () {
                return (this.value.historyActive > 0)
            },
            hasNextHistory () {
                return (this.value.history.length - 1) !== this.value.historyActive
            },
            active () {
                return this.value.history[this.value.historyActive]
            }
        },
        methods: {
            prev () {
                this.value.historyActive -= 1
            },
            next () {
                this.value.historyActive += 1
            },
            action (url, title) {
                this.$emit('action', {url, title, action: 'open', target: '_blank'})
            }
        }
    }
</script>

<style lang="stylus">
    .input-group__input > input {
        padding-top: 5px;
    }

    .interface-browser {
        &__url-title {
            font-size 15px
        }

        /deep/ .interface-browser__nav-page {
            background #c8c5c8
            box-shadow 0px 2px 4px -1px rgba(0,0,0,0.2)
        }
    }
</style>
